<template>
  <div class="uploadFile">
    <el-tooltip :content="$t('upload.仅限一篇文章')" placement="top-start" effect="light">
      <el-upload
              ref="upload"
              :action="uploadURL"
              :file-list="fileList"
              accept=".pdf, .doc, .docx, .caj, .teb, .khd, ,txt, .PDF, .DOC, .DOCX, .CAJ, .TEB, .KHD, .TXT"
              :limit="1"
              :auto-upload="false"
              :before-upload="beforeUpload"
              :on-success="afterSuccess"
              :on-error="afterError"
              :headers="headers"
      >
        <template #trigger>
          <el-button type="success" class="choose">{{$t('upload.选择文章')}}</el-button>
        </template>
      </el-upload>
    </el-tooltip>
  </div>
</template>

<script>
  import {getCurrentInstance, onMounted, reactive} from "vue";
  import {ElMessage} from "element-plus";
  import {mapGetters} from "vuex";

  export default {
    name: "UploadFile",
    emits:['uploadSuccess'],
    computed: {
      ...mapGetters(['showUploadFile'])
    },//computed
    props:{
      uploadURL:{
        type: String,
        default: '',
      }
    },
    setup(context){

      let fileList = reactive([]);
      let instance = reactive({});
      instance = getCurrentInstance();
      let headers = reactive({
        'token': localStorage.getItem('token'),
      });


      function submitUpload() {
        instance.proxy.$refs.upload.submit();
        console.log("子组件提交")
      }
      function beforeUpload(file) {
        const isLt100M = file.size / 1024 / 1024 < 100;     //这里做文件大小限制
        if(!isLt100M) {
          ElMessage({
            message: '上传文件大小不能超过 100MB!',
            type: 'warning'
          });
        }
        return isLt100M
      }
      //上传成功后的钩子
      function afterSuccess() {
        context.emit("uploadSuccess")
        //console.log('上传成功')
        //instance.ctx.$refs.upload.handleRemove();
      }
      function clearFile() {
        fileList.length = 0
      }
      //上传失败后的钩子
      function afterError() {
        console.log("error")
      }


      return{ fileList, headers,
        beforeUpload, afterSuccess, afterError, submitUpload, clearFile,
      }
    }
  }
</script>

<style scoped>

</style>